import React, {useState} from 'react';

import {useI18n} from '@udemy/i18n';
import {Image} from '@udemy/react-core-components';
import {PlayOverlay} from '@udemy/react-structure-components';

import {ClientSideVideoPlayerByAssetId} from 'src/components/client-side-video-player';

import styles from './demo-video-player.module.less';

const DEMO_VIDEO_ASSET_ID_PROD = '71138435';
const DEMO_VIDEO_ASSET_ID_DEV = '71138421';

const VIDEO_ASSET_ID_BY_SLUG: Record<string, string | undefined> = {
    'ai-professional-certificate-learning-path': DEMO_VIDEO_ASSET_ID_PROD,
    'accelerate-job-search-with-ai-learning-path': '70077933',
    'ai-essentials-learning-path': '71385335',
};

const getDemoVideoAssetIdFromSlug = (env: string, slug: string): string => {
    if (env === 'prod') {
        return VIDEO_ASSET_ID_BY_SLUG[slug] ?? DEMO_VIDEO_ASSET_ID_PROD;
    }

    return DEMO_VIDEO_ASSET_ID_DEV;
};

interface DemoVideoPlayerProps {
    acceleratorSlug: string;
    thumbnailUrl?: string;
}

export const DemoVideoPlayer: React.FC<DemoVideoPlayerProps> = ({
    acceleratorSlug,
    thumbnailUrl,
}) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const {gettext} = useI18n();
    const playerId = `gwg-plan-overview-${acceleratorSlug}`;
    const assetId = getDemoVideoAssetIdFromSlug(process.env.DEPLOY_ENV, acceleratorSlug);

    if (isPlaying || !thumbnailUrl) {
        return (
            <ClientSideVideoPlayerByAssetId
                assetId={assetId}
                playerId={playerId}
                trackingTag={playerId}
            />
        );
    }

    return (
        <button
            type="button"
            className={styles['thumbnail-button']}
            onClick={() => setIsPlaying(true)}
            aria-label={gettext('Play video preview')}
        >
            <Image
                src={thumbnailUrl}
                alt=""
                width={480}
                height={270}
                className={styles['thumbnail-image']}
            />
            <PlayOverlay className={styles['play-overlay']} />
        </button>
    );
};
